import graphSnapshot from '../data/graph-snapshot.json';

interface DatabaseEntry {
  purpose: string;
  type: string;
}

const databases = (graphSnapshot as any).databases as Record<string, DatabaseEntry[]>;

/**
 * Returns the set of database types required by the resolved services.
 * Looks up each service in graph-snapshot.json's databases section.
 */
export function getRequiredDatabaseTypes(
  resolvedServices: string[]
): Set<'mssql' | 'postgresql'> {
  const types = new Set<'mssql' | 'postgresql'>();

  for (const svc of resolvedServices) {
    const entries = databases[svc];
    if (!entries) continue;
    for (const entry of entries) {
      if (entry.type === 'mssql' || entry.type === 'jdbc' || entry.type === 'odbc') {
        types.add('mssql');
      } else if (entry.type === 'postgresql') {
        types.add('postgresql');
      }
    }
  }

  return types;
}

/**
 * Returns product display names that require the given database type.
 * Uses productServices to map product keys → services, then checks
 * each service against graph-snapshot.json's databases section.
 */
export function getProductNamesForDbType(
  productServices: Map<string, string[]>,
  products: Array<{ key: string; name: string }>,
  dbType: 'mssql' | 'postgresql'
): string[] {
  const names: string[] = [];
  for (const product of products) {
    const services = productServices.get(product.key) || [];
    let found = false;
    for (const svc of services) {
      if (found) break;
      const entries = databases[svc];
      if (!entries) continue;
      for (const entry of entries) {
        const matches = dbType === 'postgresql'
          ? entry.type === 'postgresql'
          : (entry.type === 'mssql' || entry.type === 'jdbc' || entry.type === 'odbc');
        if (matches) {
          names.push(product.name);
          found = true;
          break;
        }
      }
    }
  }
  return Array.from(new Set(names));
}
